var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "vs-btn-legacy",
      class:
        ((_obj = {}),
        (_obj[_vm.$style.VideoInPlayerOverlayButton] = true),
        (_obj[_vm.$style[_vm.alignment]] = true),
        (_obj[_vm.$style.focus] = _vm.focus),
        _obj),
      attrs: { type: "button" }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }